import React from "react";

/**
 * component svg
 */
const RemoveHighlights = function (props) {

    return (
        <svg id="clear-hl" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 1000 1000">
            <g>
                <path className="st0-hl" d="M475.2,858.4c-69.5-0.1-154.3,27.6-195.3,68.7"/>
                <path className="st1-hl" d="M281.7,664.9l499.9-463.1c29.5,22.7,57.4,47.1,83.5,73.2c26.1,26.1,50.5,53.9,73.2,83.5L475.2,858.4"/>
                <path className="st0-hl" d="M213,860.2c41.1-41,68.8-125.7,68.7-195.3"/>
                <path className="st2-hl" d="M255.8,932.7l-20.9,20.9l-89.8-6.8l62.4-62.4"/>
                <path className="st3-hl" d="M475.2,858.4c-58.6-70.5-123.1-135-193.6-193.6"/>
                <line className="st4-hl" x1="205.4" y1="867.9" x2="272.3" y2="934.8"/>
            </g>
            <line className="st5-hl" x1="75.7" y1="96.6" x2="411.4" y2="432.2"/>
            <line className="st5-hl" x1="75.7" y1="432.2" x2="411.4" y2="96.6"/>
        </svg>
    );
};

export default RemoveHighlights;
